import React from "react";
import { useDeferResource } from "modules/deferResource";
import { UserContentCheck } from "components/images";

const ProfileBackground = ({ image, children }) => {
  const url = useDeferResource(image);
  return (
    <div className="profile-background">
      <div
        className="profile-background-image"
        style={
          url
            ? {
                backgroundImage: `url('${url}')`,
              }
            : undefined
        }
      >
        {url === null && <UserContentCheck />}
      </div>
      {children}
    </div>
  );
};

export default ProfileBackground;
